import { FC, useMemo } from 'react';

import { COLORS } from '@/styles/colors';
import { Text } from '@/components/typographies';
import { DoctorSpecialistDepartment } from '@/graphql/generated/graphql';
import { DeepPartial } from '@/utils/createDeepPartial';

import * as styles from './styles';
import Verified from '../../../../assets/icons/ic_addon_verified.svg';

interface SpecialistDepartmentProps {
  departments?: DeepPartial<DoctorSpecialistDepartment[]> | null;
}

const SpecialistDepartment: FC<SpecialistDepartmentProps> = (props) => {
  const { departments } = props;

  const specialistDepartment = useMemo(() => {
    return departments?.find((department) => department?.representative);
  }, [departments]);

  return specialistDepartment ? (
    <div className={styles.container}>
      <Verified width={18} height={18} color={COLORS.BLUE_70} />
      <Text
        type={'body2_700'}
        color={COLORS.BLUE_70}
      >{`${specialistDepartment.specialistDepartment?.name} 전문의`}</Text>
    </div>
  ) : null;
};

export default SpecialistDepartment;
